import { Component } from '@angular/core';

interface HistoryTimelineEntry {
  year: string;
  descriptionKeys: string[];
}

@Component({
  selector: 'about-us-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css'],
})
export class HistoryComponent {
  timelineEntries: HistoryTimelineEntry[] = [
    { year: '2007', descriptionKeys: ['ABOUT-US_HISTORY-TIMELINE-2007'] },
    { year: '2008', descriptionKeys: ['ABOUT-US_HISTORY-TIMELINE-2008'] },
    { year: '2009', descriptionKeys: ['ABOUT-US_HISTORY-TIMELINE-2009'] },
    { year: '2010', descriptionKeys: ['ABOUT-US_HISTORY-TIMELINE-2010'] },
    { year: '2013', descriptionKeys: ['ABOUT-US_HISTORY-TIMELINE-2013'] },
    {
      year: '2014',
      descriptionKeys: ['ABOUT-US_HISTORY-TIMELINE-2014-A', 'ABOUT-US_HISTORY-TIMELINE-2014-B'],
    },
    { year: '2015', descriptionKeys: ['ABOUT-US_HISTORY-TIMELINE-2015'] },
    { year: '2016', descriptionKeys: ['ABOUT-US_HISTORY-TIMELINE-2016'] },
    { year: '2017', descriptionKeys: ['ABOUT-US_HISTORY-TIMELINE-2017'] },
    { year: '2020', descriptionKeys: ['ABOUT-US_HISTORY-TIMELINE-2020'] },
    { year: '2023', descriptionKeys: ['ABOUT-US_HISTORY-TIMELINE-2023'] },
  ];

  trackByYear(_index: number, entry: HistoryTimelineEntry): string {
    return entry.year;
  }

  trackByDescription(_index: number, descriptionKey: string): string {
    return descriptionKey;
  }
}
